/**
 * 用户系统模块，负责所有有关用户系统的操作，如登陆，注册等
 *
 * @author mingxin.huang
 * @update 2013.08.21
 */
$.module('MM.user', function () {
  var _actions = {
    extraUserInfo: 'user/info/{access_token}?qd={qd}&child_qd={child_qd}',
    logout: 'user/logout/{access_token}',
    // securityInfo: 'user/info_complete?access_token={access_token}',
    securityInfo: MM.core.getRoot('show?access_token={access_token}', 'user'),
  };

  var CONST_ARY = [
      '保密',
      '白羊座',
      '金牛座',
      '双子座',
      '巨蟹座',
      '狮子座',
      '处女座',
      '天秤座',
      '天蝎座',
      '射手座',
      '魔蝎座',
      '水瓶座',
      '双鱼座',
    ], //星座数组
    STATURE_M_ARY = ['消瘦', '结实', '强壮', '魁梧'], //男性身材数组
    STATURE_F_ARY = ['苗条', '丰满', '丰硕', '富态'], //女性身材数组
    TTSHOW_TAG = 'TTSHOW_USER_INFO', //秀场用户信息标记
    USER_TOKEN_TAG = 'ACCESS_TOKEN'; //用户单一token标记

  var _userInfo = null,
    _userToken = '',
    _getExtraOnce = false; //是否已经拿取过一次多余信息,

  //模块初始化
  function _init() {
    $.extend(MM.user, MM.user.register);
    $.extend(MM.user, MM.user.login);
    MM.user.extraInit();

    _registerEvents();

    MM.user.refreshToken.init();

    if (_isLogin()) {
      //判断oauth2下进入直播间刷新token逻辑
      _getUserInfo();
      _getExtraUserInfo(function (userInfo) {
        MM.user.confirmAgreement.init();
        MM.fixedbar.main.init();
        // 注册神策公共字段，初始化方法
        MM.util.sdata.registerSdata({ userInfo: _userInfo });
      });
    } else {
      MM.fixedbar.main.init();
      switch ($.query.get('action')) {
        case 'login':
          MM.user.popupLogin();
          break;
        case 'register':
          MM.user.popupRegister();
          break;
        default:
          break;
      }
    }
  }

  function _registerEvents() {
    $('body')
      .delegate('.j_popup_login', 'click', function () {
        MM.user.popupLogin();
      })
      .delegate('.j_popup_register', 'click', function () {
        MM.user.popupRegister();
      })
      .delegate('.j_logout', 'click', _logout)
      .delegate('.j_kefu', 'click', MM.user.kefu.showKefu)
      .delegate('.j_redirect_login', 'click', function () {
        MM.user.redirectToLogin($(this).data('type'));
      });
  }

  /**
   * 获取星愿系统用户数据
   * @param  {Function} successCallback 成功回调函数
   * @param  {Function} errorCallback   失败回调函数
   * @return {[type]}                 [description]
   */
  function _getExtraUserInfo(successCallback, errorCallback) {
    if (!_getToken()) {
      return;
    }

    MM.core.getResult({
      url: _actions.extraUserInfo,
      data: {
        qd: MM.user.getFrom(),
        child_qd: MM.user.getSubFrom(),
      },
      requireToken: true,
      success: function (res) {
        _getExtraOnce = true;

        //这里处理一些默认值
        var tmpUserInfo = $.extend(
          true,
          {
            finance: {
              bean_count: 0,
              bean_count_total: 0,
              coin_count: 0,
              coin_spend_total: 0,
              profit: 0, // 收益余额 单位：分
              profit_award: 0, // 奖励余额 单位：分
              profit_total: 0, // 总收益
              benefit_total: 0, // 主播经验值，对应流水，用于计算新的 主播等级
            },
            enter_info_bg: 1,
            m_vip: 0,
            pay_level_info: {
              level: 0,
            },
          },
          res.data,
        );

        _setUserInfo(tmpUserInfo);

        if (CURRENT_APP.v1) {
          Sentry.configureScope(function (scope) {
            scope.setUser({
              id: _userInfo._id,
              username: _userInfo.nick_name,
            });
          });
        }

        MM.user.sendLoginLog();

        _callbacks.fire();
        _callbacks.empty();

        successCallback && successCallback(tmpUserInfo);
      },
      error: function (err) {
        if (typeof errorCallback == 'function') {
          errorCallback();
        }
      },
    });
  }

  // 获取用户token
  function _getToken() {
    if (_userToken) {
      return _userToken;
    }

    // url中的access_token
    var queryToken = $.query.get('access_token');
    if (queryToken) {
      var _token = _getCacheToken() || '';
      _setUserOriginToken(queryToken);
      //对于传access_token过来的  对比已存在本地token信息   如果相同说明本地已经有用户信息
      //第一次传token过来刷新页面
      if (_token != queryToken || !_getUserInfo()) {
        _getExtraUserInfo(function () {
          var url = $.query.clear('access_token', location.href);
          MM.core.debug('url:', url);
          location.href = url;
        });
      }

      if (_token === queryToken) {
        var url = $.query.clear('access_token', location.href);
        location.href = url;
      }

      return queryToken;
    }

    function _getCacheToken() {
      // cookie中的token

      if ($.store.get(USER_TOKEN_TAG)) {
        _userToken = $.store.get(USER_TOKEN_TAG);
        return _userToken;
      }
      return '';
    }

    return _getCacheToken();
  }

  /**
   * 获取用户信息
   * @return {Object} 用户个人信息
   */
  function _getUserInfo() {
    if (_userInfo) {
      return _.assign({}, _userInfo);
    }

    var tempUserInfo = $.store.get(TTSHOW_TAG);

    if (tempUserInfo) {
      _userInfo = tempUserInfo;

      return _userInfo;
    }

    return null;
  }

  /**
   * 获得用户ID
   * @return {[type]} [description]
   */
  function _getUserId() {
    return _getUserInfo() ? _getUserInfo()._id : null;
  }

  /**
   * 第三方登录回调接口
   * @param  {String} search 回调所带search
   */
  function _resolveUserResult(search) {
    MM.core.debug('resolveUserResult search:', search);
    var token = $.query.get('access_token', search);
    var mobile = $.query.get('en_mobile', search);
    var security = $.query.get('security_checks', search);

    MM.ui.popup.hide(true);

    if (!security && mobile) {
      return MM.user.register.popupRegister('safeCheck', {
        access_token: token,
        en_mobile: mobile,
      });
    }

    if (token) {
      MM.log.send({
        event: 'user',
        event_type: 'third_login',
      });
      MM.ui.messager.loading('登录中,请稍等');
      _setUserOriginToken(token);
      _getExtraUserInfo(function () {
        location.reload();
      });
    }
  }

  window.resolveUserResult = _resolveUserResult; //开放一个全局的方法用于子窗口回调登陆方法

  /**
   * 设置用户信息
   * @param {[Object]} info 用户数据
   */
  function _setUserInfo(info, isDisableRender) {
    _userInfo = $.extend(true, _userInfo, info);

    $.store.set(TTSHOW_TAG, _userInfo);

    if (!isDisableRender) {
      // 渲染侧边栏信息
      MM.fixedbar.main.renderTop();
    }
  }

  /**
   * 设置用户原始token
   * @param {String} token      token
   * @param {String/Number} expires_at 过期时间
   */
  function _setUserOriginToken(token) {
    _userToken = token;

    $.store.set(USER_TOKEN_TAG, _userToken);
  }

  function _getCoinLevel() {
    return MM.level.getCoinLevel(_.get(_getUserInfo(), 'finance.coin_spend_total', 0));
  }

  function _getRichLevel() {
    return MM.level.getRichLevel(_.get(_getUserInfo(), 'finance.coin_spend_total', 0));
  }

  function _getStarLevel() {
    return MM.level.getStarLevel(_.get(_getUserInfo(), 'finance.coin_spend_total', 0));
  }

  //获取用户的富豪等级  不推荐使用
  function _getRichLv() {
    return _isLogin() && _getUserInfo()
      ? MM.level.getLevel(_getUserInfo().finance.coin_spend_total, true).level
      : 0;
  }

  /**
   * 获取主播等级    不推荐使用
   * @return {Number} 主播等级
   */
  function _getStarLv() {
    return _isLogin() && _getUserInfo()
      ? MM.level.getStarLevel(_getUserInfo().finance.benefit_total).level
      : 0;
  }

  // 判断是否为登陆状态
  function _isLogin() {
    return !!_getToken();
  }

  // 分辨是否为某一类用户
  function _detectIdentity(type, value) {
    if (_isLogin() && _getUserInfo() !== null) {
      var typeAry = type.split('.'),
        tempVal = _userInfo;

      for (var i = 0; i < typeAry.length; i++) {
        if ($.exists(tempVal[typeAry[i]])) {
          tempVal = tempVal[typeAry[i]];
        } else {
          break;
        }
      }

      return tempVal == value;
    } else {
      return false;
    }
  }

  //是否为运营
  function _isOperate(priv) {
    if (!priv) {
      return _detectIdentity('priv', 1);
    } else {
      return priv == 1;
    }
  }

  // 是否为主播
  function _isStar(priv) {
    if (priv) {
      return priv === 2;
    }
    return _detectIdentity('priv', 2);
  }

  //是否为主播 PC 上申请的主播
  // apply_type =  0-全部,1-PC,2-手机,3-VR,4-VOICE,5-GM_ROOM
  function _isAnchor(priv) {
    if (priv) {
      return priv === 2;
    }
    return _detectIdentity('priv', 2); //&&
    // (_getUserInfo().apply_type !== 2 || !_getUserInfo().apply_type);//
  }

  //是否为主播 移动端 上申请的主播
  // function _isMobileAnchor() {
  //     return _detectIdentity('priv', 2) //&& _getUserInfo().apply_type == 2;
  // }

  //是否是特殊主播 (支持手机，pc开播)  没有这个字段说明是 仅支持手机开播，前提是主播身份
  // function _isSpecialStar() {
  //     return _getUserInfo() && !!_getUserInfo().special_star
  // }

  //是否为客服
  function _isService(priv) {
    if (!priv) {
      return _detectIdentity('priv', 4);
    } else {
      return priv === 4;
    }
  }

  //是否为经纪人
  function _isBroker(priv) {
    if (!priv) {
      return _detectIdentity('priv', 5);
    } else {
      return priv == 5;
    }
  }

  // 是否为普通用户
  function _isCommonUser(priv) {
    if (!priv) {
      return _detectIdentity('priv', 3);
    } else {
      return priv == 3;
    }
  }

  // 是否为VIP用户
  function _isVip(vip) {
    if (typeof vip == 'undefined' && _isLogin() && _getUserInfo()) {
      return $.isNumeric(_getUserInfo().vip) && _getUserInfo().vip != 0;
    } else if ($.isNumeric(vip)) {
      return vip != 0;
    } else {
      return false;
    }
  }

  // 判断是否是自己
  function _isSelf(id) {
    return _detectIdentity('_id', id);
  }

  // 判断是否有家族
  function _hasFamily() {
    return _isLogin() ? !!_getUserInfo().family : false;
  }

  // 获取家族信息
  function _getFamilyInfo() {
    return _hasFamily() ? _getUserInfo().family : null;
  }

  // 设置家族信息
  function _setFamilyInfo(key, value) {
    if (_hasFamily()) {
      _getUserInfo().family[key] = value;
    }
  }

  // 区分用户在家族中的身份
  function _detectFamilyIdentity(priv, familyId) {
    if (!_hasFamily()) {
      return false;
    }

    var familyData = _getUserInfo().family;
    var privRes = familyData.family_priv === priv;

    if (familyId) {
      return privRes && familyData.family_id === familyId;
    }

    return privRes;
  }

  /**
   * 是否是某家族房族长和副族长
   * @param  {Number}  room_id 家族房ID
   * @return {Boolean}         [description]
   */
  function _isRoomLeader(room_id) {
    if (!_isFamilyLeader() && !_isFamilyViceLeader()) {
      return false;
    }

    return _userInfo.family.family_id === room_id;
  }

  // 是否为家族的族长
  function _isFamilyLeader(familyId) {
    return _detectFamilyIdentity(1, familyId);
  }

  // 是否为家族的副族长
  function _isFamilyViceLeader(familyId) {
    return _detectFamilyIdentity(2, familyId);
  }

  // 是否为家族的主播
  function _isFamilyAnchor(familyId) {
    return _detectFamilyIdentity(3, familyId);
  }

  // 是否为家族的普通成员
  function _isFamilyMember(familyId) {
    return _detectFamilyIdentity(4, familyId);
  }

  //是否有靓号
  function _hasMMNo() {
    return _userInfo.mm_nos && _userInfo.mm_nos.length > 0; //_userInfo._id !== _userInfo.mm_no;
  }

  //获取靓号
  function _getMMNo() {
    return _userInfo.mm_no;
  }

  /**
   * 判断是否已经绑定过手机号
   * @param  {Function} callback 判断回调
   * @param  {Boolean} isRefresh 是否是强制重新获取数据
   */
  function _isMobileBinded(callback, isRefresh) {
    if (!$.isFunction(callback)) {
      return;
    }

    if ($.exists(_userInfo.securityInfo) && isRefresh !== true) {
      return callback(_userInfo.securityInfo.mobile_bind);
    }

    _getSecurityInfo(function (securityInfo) {
      callback(securityInfo.mobile_bind);
    });
  }

  /**
   * 获取用户隐私信息
   * @param  {Function} callback 回调函数
   */
  function _getSecurityInfo(callback, isAll) {
    MM.core.getResult({
      url: _actions.securityInfo,
      requireToken: true,
      success: function (res) {
        var data = res.data;
        _setUserInfo({ securityInfo: data });

        callback && callback(data);
      },
    });
  }

  // 退出登陆
  function _logout() {
    var logout = function () {
      _clearUserInfo();

      if (/user.html/.test(location.pathname)) {
        location.href = '/';
      } else {
        if (location.search.indexOf('callback') > -1) {
          location.href = $.query.set('callback', '').replace(/[?|&]callback=/, '');
        } else {
          location.reload();
        }
      }
    };

    if (_isLogin()) {
      MM.core.getResult({
        url: _actions.logout,
        success: logout,
        resolveError: logout,
      });
    }
  }

  /**
   * 清除用户信息
   */
  function _clearUserInfo() {
    _userInfo = null;
    $.store.remove(USER_TOKEN_TAG);
    $.store.remove(TTSHOW_TAG);
    MM.user.refreshToken.clear();
  }

  // 身份过期处理 只弹一次
  var _is_show_expired = false;

  function _expired() {
    if (!_is_show_expired) {
      MM.log.send({
        event: 'user',
        event_type: 'user_expired',
      });

      if (window['inPcClient']) {
        _clearUserInfo();
        _is_show_expired = false;
      } else {
        MM.ui.messager.warn('您的身份已经过期，请重新登录', function () {
          _clearUserInfo();
          location.href = '/';
          _is_show_expired = false;
        });
      }
    }
    _is_show_expired = true;
  }

  /**
   * 注册登陆成功后获取到用户信息的回调函数
   * @param  {Function} callback [description]
   * @return {[type]}            [description]
   */
  var _callbacks = $.Callbacks(); //回调函数控制
  function _registerExtraCallback(callback) {
    if (typeof callback !== 'function') {
      return;
    }

    _callbacks.add(callback);

    if (_getExtraOnce) {
      _callbacks.fire();
      _callbacks.empty();

      return;
    }
  }

  // 获取星座数组
  function _getConstAry() {
    return CONST_ARY;
  }

  // 获取用户星座
  function _getUserConst() {
    if (!_isLogin()) {
      return;
    }

    return CONST_ARY[_userInfo.constellation || 0];
  }

  // 是否是 男性  1：男性，0：女性
  function _isMan(sex) {
    var _sex = _.get(_userInfo, 'sex', 0);
    if (typeof sex !== 'undefined') {
      _sex = sex;
    }
    return _sex === 1;
  }

  // 获取体型
  function _getStature() {
    if (!_isLogin()) {
      return;
    }

    var tempAry = _userInfo.sex === 1 ? STATURE_M_ARY : STATURE_F_ARY;

    return tempAry[_userInfo.stature ? (_userInfo.stature < 0 ? 0 : _userInfo.stature) : 0];
  }

  // 获取体型数组
  function _getStatureAry(text) {
    var USER_SEX = text ? parseInt(text, 10) : _userInfo.sex;
    if (USER_SEX === 1) {
      return STATURE_M_ARY;
    }

    return STATURE_F_ARY;
  }

  // 获取请求的路径
  function _getActions() {
    return _actions;
  }

  // 是否 完善手机号
  function _isCompleteMobileBind() {
    return _.get(_userInfo, 'detail_info.mobile_bind');
  }

  // 是否 绑定手机号 同步方式 _isMobileBinded 与 该方法相同，为异步获取是否绑定手机号信息
  function _isMobileBind() {
    return _.get(_userInfo, 'mobile_bind');
  }

  return {
    init: _init,
    getToken: _getToken,
    getUserInfo: _getUserInfo,
    setUserInfo: _setUserInfo,
    getUserId: _getUserId,
    getSecurityInfo: _getSecurityInfo,
    getCoinLevel: _getCoinLevel,
    getRichLevel: _getRichLevel,
    getStarLevel: _getStarLevel,
    getRichLv: _getRichLv,
    getStarLv: _getStarLv,
    isMan: _isMan,
    isLogin: _isLogin,
    isOperate: _isOperate,
    isAnchor: _isAnchor,
    isStar: _isStar,
    // isMobileAnchor: _isMobileAnchor,
    isService: _isService,
    isBroker: _isBroker,
    isCommonUser: _isCommonUser,
    isVip: _isVip,

    clearUserInfo: _clearUserInfo,

    isSelf: _isSelf,
    isMobileBinded: _isMobileBinded,
    hasFamily: _hasFamily,
    getFamilyInfo: _getFamilyInfo,
    setFamilyInfo: _setFamilyInfo,
    isFamilyMember: _isFamilyMember,
    isFamilyLeader: _isFamilyLeader,
    isFamilyViceLeader: _isFamilyViceLeader,
    isRoomLeader: _isRoomLeader,
    hasMMNo: _hasMMNo,
    getMMNo: _getMMNo,
    logout: _logout,
    expired: _expired,
    getConstAry: _getConstAry,
    getUserConst: _getUserConst,
    getStature: _getStature,
    getStatureAry: _getStatureAry,
    getActions: _getActions,
    getExtraUserInfo: _getExtraUserInfo,
    setUserOriginToken: _setUserOriginToken,
    registerExtraCallback: _registerExtraCallback,
    isCompleteMobileBind: _isCompleteMobileBind,
    isMobileBind: _isMobileBind,
    // isSpecialStar: _isSpecialStar
  };
});
